






























































import Vue from "vue";
import Customer from "@/types/customer/Customer";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";
import { Watch } from "vue-property-decorator";
import Endpoint from "@/utils/endpoint";

const namespace = "customer";

@Component({})
export default class ModalDetail extends Vue {
  @Getter("getCustomer", { namespace }) customer!: Customer;
  @Getter("getUndoRefused", { namespace }) undoRefused!: boolean;
  @Getter("getLoading", { namespace: "customer" }) loading!: boolean;
  @Getter("getModalRefusedState", { namespace: "customer" })
  ModalRefusedState!: boolean;

  @Action("setUndoRefused", { namespace }) setUndoRefused!: any;
  @Action("setLoading", { namespace: "customer" }) setLoading!: any;
  @Action("setModalRefusedState", { namespace: "customer" })
  setModalRefusedState!: any;

  private endpoint = new Endpoint();

  refusing = false;
  successRefused = false;
  commentForRefuse = "";

  undoRefuseClient(): void {
    this.refusing = true;
    this.setLoading(true);
    this.$http
      .put(this.endpoint.undoRefuse, {
        refuseCustomer: {
          customerId: this.customer.id,
          comment: this.commentForRefuse
        }
      })
      .then(resp => {
        this.customer.refuseComment = this.commentForRefuse;
        this.commentForRefuse = "";

        this.refusing = false;

        this.successRefused = true;
        this.setModalRefusedState(false);
        this.setUndoRefused(true);
        this.setLoading(false);
      })
      .catch(err => {
        this.refusing = false;
        this.setLoading(false);
      });
  }

  closeModal(): void {
    this.setUndoRefused(false);
  }
}
